/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGitCherryPick = createReactComponent("git-cherry-pick", "IconGitCherryPick", [
  ["path", { d: "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M7 3v6", key: "svg-1" }],
  ["path", { d: "M7 15v6", key: "svg-2" }],
  ["path", { d: "M13 7h2.5l1.5 5l-1.5 5h-2.5", key: "svg-3" }],
  ["path", { d: "M17 12h3", key: "svg-4" }]
]);

export { IconGitCherryPick as default };
//# sourceMappingURL=IconGitCherryPick.js.map
